import getNonHiddenPaymentOptionsForSelectedCategory from './getNonHiddenPaymentOptionsForSelectedCategory';
import {getPaymentOptionDisabledStatuses, getPaymentOptionHiddenStatuses} from './PaymentOptionDisabledSelectors';

export default (state) => {
  const optionDisabledStatuses = getPaymentOptionDisabledStatuses(state);
  const optionHiddenStatuses = getPaymentOptionHiddenStatuses(state);
  const nonHiddenPaymentOptionsForSelectedCategory = getNonHiddenPaymentOptionsForSelectedCategory(state);
  const optionHiddenForCategoryStatuses = [];
  
  optionHiddenStatuses.forEach((_, index) => {
    if (nonHiddenPaymentOptionsForSelectedCategory.some(paymentOption => paymentOption.apiIndex === index)) {
      optionHiddenForCategoryStatuses.push(false);
    } else {
      optionHiddenForCategoryStatuses.push(true);
    }
  });
  
  const availablePaymentOptionArray = optionDisabledStatuses.map((bool, index) => !bool && !optionHiddenStatuses[index] && !optionHiddenForCategoryStatuses[index]);
  return availablePaymentOptionArray.indexOf(true);
};
